<div class="d-flex justify-content-center align-items-center my-5" *ngIf="!categories">
  <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>

<div class="menu">
<div *ngFor="let object of categories" class="menu--item" [routerLink]="['/home', object?.site_url]" dimensions (click)=onCategoryChange(object.sort)>
<div>
  <img *ngIf="object?.img" [ngClass]="{'link--current': '/home/' + object?.site_url === link,
         'link--not-current': '/home/' + object?.site_url !== link}" [attr.data-src]="object?.img"
    alt="Categories image" loading="lazy" width="64" height="64">
</div>
  <span class="menu--item__title" [ngStyle]="menuStyle?.value?.label" [ngClass]="{'name--current': '/home/' + object?.site_url === link,
         'name--not-current': '/home/' + object?.site_url !== link}">{{object?.name}}</span>
</div>
  <div *ngIf="needShowEcoPizza" class="menu--item" (click)=ecoPizzaNavigate()>
    <div>
      <img class="link--not-current" src="assets/icons/pizza.webp" alt="eco pizza logo" loading="lazy" width="64"
           height="64">
    </div>
    <span class="menu--item__title name--not-current" [ngStyle]="menuStyle?.value?.label">Eco Pizza</span>
  </div>
</div>
